<template>
  <el-row :gutter="20" style="margin-top: 10%">
    <el-col :span="12" :offset="6">
      <el-card class="box-card">
        <!-- <img
          style="margin: 0 auto; display: block"
          src="@/assets/images/golden_logo.png"
          alt="Logo"
        /> -->
        <img
          style="margin: 0 auto; display: block"
          src="@/assets/images/logo_black.png"
          alt="Logo"
        />
        <h2>Login</h2>

        <el-form :model="form" :label-position="'left'" label-width="100px">
          <el-form-item label="Email">
            <el-input type="email" v-model="form.email" />
          </el-form-item>
          <el-form-item label="Password">
            <el-input
              v-model="form.password"
              type="password"
              autocomplete="off"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" plain @click="onSubmit">Login</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </el-col>
  </el-row>
</template>
<script>
import { mapActions } from "vuex";

export default {
  name: "LoginView",
  data() {
    return {
      form: {
        email: "",
        password: "",
      },
    };
  },
  methods: {
    ...mapActions("auth", ["login"]),

    onSubmit() {
      this.login(this.form).then(
        () => {
          this.$notify({
            title: "Success",
            message: "Login Successful",
            type: "success",
          });

          this.$router.push("/dashboard");
        },
        (error) => {
          this.$notify({
            title: "Error",
            message: error.response.data.message,
            type: "error",
          });
        }
      );
    },
  },
};
</script>
